import cx from 'classnames';
import { LoadingMask } from 'Elements';
import styles from 'partials/sidebar-list-loading.module.scss';

export const SidebarListLoading = () => {
	return (
		<div className={styles.box}>
			<div className={styles.row}>
				<LoadingMask className={cx(styles.col, styles.colSmall)} />
				<LoadingMask className={cx(styles.col, styles.colBig)} />
			</div>
			<div className={styles.row}>
				<LoadingMask className={cx(styles.col, styles.colSmall)} />
				<LoadingMask className={cx(styles.col, styles.colBig)} />
			</div>
			<div className={styles.row}>
				<LoadingMask className={cx(styles.col, styles.colSmall)} />
				<LoadingMask className={cx(styles.col, styles.colBig)} />
			</div>
			<div className={styles.row}>
				<LoadingMask className={cx(styles.col, styles.colSmall)} />
				<LoadingMask className={cx(styles.col, styles.colBig)} />
			</div>
		</div>
	);
};
